import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import { FormControlService } from '../form-control.service';
import { FormControlServiceBase } from '../types/form-control-service.base';
import { IDisposable } from '../types/i-disposable';

const PHONE_NUMBER_SPLITTER = '-'

@Injectable()
export class PhoneFormControlService implements FormControlServiceBase<'phone'>, OnDestroy {


  readonly _destory = new Subject<true>();
  readonly prefixSubject = new BehaviorSubject<string>('');
  readonly phoneNumberSubject = new BehaviorSubject<string>('');

  readonly valueSubject = this._formControlService.valueSubject;

  readonly disposables: IDisposable[] = [];

  constructor(
    private _formControlService: FormControlService<string>
  ) {
    this._initSubjectsBalanceSubscriptions()

  }

  private _initSubjectsBalanceSubscriptions() {

    this.prefixSubject
      .pipe(
        takeUntil(this._destory)
      )
      .subscribe((prefix) => {
        const value = this.valueSubject.value;

        if (!value) {
          this.valueSubject.next(prefix + PHONE_NUMBER_SPLITTER);
          return;
        }

        const [currentPrefix, currentNumber] = value.split(PHONE_NUMBER_SPLITTER)

        if (currentPrefix == prefix) {
          return;
        }

        if (!prefix && !currentNumber) {
          this.valueSubject.next('');
        }

        this.valueSubject.next([prefix, currentNumber].join(PHONE_NUMBER_SPLITTER))
      })

    this.phoneNumberSubject
      .pipe(
        takeUntil(this._destory)
      )
      .subscribe((phoneNumber) => {
        const value = this.valueSubject.value;

        if (!value) {
          this.valueSubject.next(PHONE_NUMBER_SPLITTER + phoneNumber);
          return;
        }

        const [currentPrefix, currentNumber] = value.split(PHONE_NUMBER_SPLITTER)

        if (currentNumber == phoneNumber) {
          return;
        }

        if (!currentPrefix && !phoneNumber) {
          this.valueSubject.next('');
        }

        this.valueSubject.next([currentPrefix, phoneNumber].join(PHONE_NUMBER_SPLITTER))
      })

    this.valueSubject
      .subscribe((value) => {

        const prefix = this.prefixSubject.value;
        const phoneNumber = this.phoneNumberSubject.value;



        const [newPrefix, newNumber] = (value || '').split(PHONE_NUMBER_SPLITTER)

        if (newPrefix != prefix) {
          this.prefixSubject.next(newPrefix);
        }

        if (phoneNumber != newNumber) {
          this.phoneNumberSubject.next(newNumber);
        }


      })

  }


  ngOnDestroy(): void {



    this._destory.next(true);
    this._destory.complete();
  }


}
